<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12">
            <v-select
              data-cy="FormEmail-emailType"
              filled
              :label="$$t('emailType')"
              :items="['Confirmation Email']"
              v-model="localEmail.emailType"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormEmail-emailAddress"
              :label="$$t('emailAddress')"
              v-model="localEmail.emailAddress"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormEmail-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormEmail-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormEmail',
  module: 'Shop',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Email: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localEmail
      */
      localEmail: {},
    };
  },
  watch: {
    Email() {
      this.localEmail = this.Email;
    },
  },
  created() {
    this.localEmail = this.Email;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localEmail);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormEmail example

'''js
<FormEmail :Email="Email" />
'''
</docs>
